var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adminlogin"},[_c('div',{staticClass:"adminlogin_box"},[_c('div',{staticClass:"adminlogin_form",style:({'minHeight':_vm.minheight})},[_vm._t("default")],2)]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adminlogin_footer"},[_c('p',[_vm._v("Copyright © 2019-2024 All Rights Reserved"),_c('br'),_vm._v("四川一播红品牌管理有限公司版权所有 蜀ICP备2026005867号-2")])])
}]

export { render, staticRenderFns }